/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { modalContainer } from "@/src/theme/commonStyle";

const emailChangeStyle = {
  form: {
    paddingBottom: "2rem",
  },
  modalContainer,
};

export default emailChangeStyle;
